// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"f7102fae","662":"0715330c","692":"5fbbd266"}[chunkId] + ".chunk.js";
};